<ng-template #confirmationModalForm let-modal>
  <div class="modal-body text-center">
    <div>
      <div class="text-center">
        <div class="mb-4">
          <lord-icon
            [colors]="colors"
            [src]="animationLink"
            style="width:120px;height:120px"
            trigger="loop"
          >
          </lord-icon>
        </div>
        <h4 class="mb-3"><span [innerHtml]="mainMessage"></span></h4>
        <p class="text-muted mb-4"><span [innerHtml]="subMessage"></span></p>
        @if (confirmText) {
          <label class="form-label" for="confirmTypedInput">Type <strong>{{confirmText}}</strong> to confirm</label>
          <input type="text" class="form-control text-center" id="confirmTypedInput" autocomplete="off" [value]="confirmTyped" (input)="confirmTypedChanged($event)">
        }
      </div>
    </div>
    <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
      <button type="button" class="btn w-sm btn-danger " id="delete-product" [disabled]="!confirmTextMatches" (click)="modalYesSelected()">{{yesText}}</button>
      <button class="btn btn-link link-success fw-medium text-decoration-none" data-bs-dismiss="modal" (click)="modalNoSelected()"><i class="ri-close-line me-1 align-middle"></i>{{noText}}</button>
    </div>
  </div>
</ng-template>
